// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.10.0",
  date: "2026-09-28T06:34:37.252Z",
  gitInfo: {
    dirty: false,
    raw: "217c8d2bb",
    hash: "217c8d2bb",
    distance: null,
    tag: null,
    semver: null,
    suffix: "217c8d2bb",
    semverString: null
  }
};
/* tslint:enable */
